// Data de nascimento das contas: obrigatória ao criar e só para maiores de 18 anos.
// Mesmas regras do backend (validateBirthDate em index.js) — o backend é quem garante.
export const ACCOUNT_MIN_AGE = 18

const pad = (n: number) => String(n).padStart(2, '0')

// Data máxima aceita no <input type="date"> (hoje − 18 anos)
export function maxBirthDate(): string {
  const d = new Date()
  return `${d.getFullYear() - ACCOUNT_MIN_AGE}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const MIN_BIRTH_DATE = '1900-01-01'

// Retorna a mensagem de erro, ou '' se a data for válida
export function birthDateError(value: string): string {
  const m = `${value || ''}`.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!m) return 'Informe a data de nascimento.'
  const [year, month, day] = [Number(m[1]), Number(m[2]), Number(m[3])]
  const date = new Date(year, month - 1, day)
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day || year < 1900) return 'Data de nascimento inválida.'
  const today = new Date()
  let age = today.getFullYear() - year
  if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age--
  if (age < 0) return 'Data de nascimento inválida.'
  if (age < ACCOUNT_MIN_AGE) return `É necessário ter pelo menos ${ACCOUNT_MIN_AGE} anos para ter uma conta.`
  return ''
}
